import * as amplitude from '@amplitude/analytics-browser';

import {
  AnalyticsClient,
  createUseAnalytics,
} from '@aorg/hooks/analytics';

const client = amplitude as unknown as AnalyticsClient;

const resolveEnv = () => {
  const url = import.meta.env.VITE_API_URL;
  if (url?.includes('.dev')) return 'staging';
  if (url?.includes('.org')) return 'production';
  return 'local';
};

const useAmplitude = createUseAnalytics({
  client,
  resolveApiKey: () => import.meta.env.VITE_AMPLITUDE_API_KEY,
  resolveEnv,
  platform: 'Web',
  os: 'Browser',
  initOptions: {
    fetchRemoteConfig: true,
    autocapture: {
      attribution: false,
      pageViews: false,
      sessions: true,
      formInteractions: false,
      fileDownloads: false,
      elementInteractions: false,
    },
  },
  onApiKeyMissing: () => {
    if (import.meta.env.DEV) console.log('Amplitude API Key not found');
  },
});

export default useAmplitude;
